import { 
    Form, 
    Input, 
    Modal, 
    Button, 
    Space,
    Divider,
    Row as AntRow,
    Col
} from "antd";
import { 
    EditOutlined, 
    CloseOutlined,
    BookOutlined
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { editCategoryRequest } from "../../redux/controller";
import { useDispatchRoot } from "../../redux/store";
import { confirmCloseModal } from '../modalEditBook/CModalConfirmClose';

interface MyProps {
    open: boolean;
    data?: any;
    setOpenModalEdit: React.Dispatch<React.SetStateAction<boolean>>;
}

const CModalEditCategory = (props: MyProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    
    const dispatch = useDispatchRoot();
    const [form] = Form.useForm();
    const values = Form.useWatch([], form);

    useEffect(() => {
        if (props.data) {
            form.setFieldsValue({
                name: props.data.name,
                description: props.data.description
            });
            setHasChanges(false);
        }
    }, [props.data]);

    useEffect(() => {
        const currentValues = form.getFieldsValue();
        const hasFormChanges = 
            currentValues.name !== props.data?.name ||
            currentValues.description !== props.data?.description;
        
        setHasChanges(hasFormChanges);
    }, [values]);

    const handleEditCategory = async () => {
        setIsLoading(true);
        try {
            const bodyRequest = {
                id: props.data?.id,
                name: form.getFieldsValue().name,
                description: form.getFieldsValue().description,
            };
            
            await dispatch(editCategoryRequest(bodyRequest));
            
            props.setOpenModalEdit(false);
        } catch (error) {
            console.error("Error editing category:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancelEditCategory = () => {
        confirmCloseModal({
            hasChanges,
            onConfirm: () => {
                resetForm();
                props.setOpenModalEdit(false);
            },
            title: 'Xác nhận đóng',
            content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal chỉnh sửa thể loại?'
        });
    };

    const resetForm = () => {
        setHasChanges(false);
        form.resetFields();
    };

    return (
        <Modal
            open={props.open}
            onCancel={handleCancelEditCategory}
            title={
                <Space>
                    <EditOutlined />
                    <span>Chỉnh sửa thể loại</span>
                </Space>
            }
            className="category-edit-modal"
            footer={null}
            width={600}
            destroyOnClose
            maskClosable={true}
        >
            <div className="modal-content">
                <Form
                    initialValues={props.data}
                    form={form}
                    className="category-form"
                    layout="vertical"
                    onFinish={handleEditCategory}
                >
                    <AntRow gutter={[16, 12]}>
                        <Col span={24}>
                            <Form.Item
                                label={
                                    <Space>
                                        <BookOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                        <span>Tên thể loại</span>
                                    </Space>
                                }
                                name="name"
                                rules={[{ required: true, message: 'Vui lòng nhập tên thể loại!' }]}
                            >
                                <Input
                                    placeholder="Nhập tên thể loại"
                                    className="form-input"
                                />
                            </Form.Item>
                        </Col>
                        
                        <Col span={24}>
                            <Form.Item
                                label={
                                    <Space>
                                        <BookOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                        <span>Mô tả thể loại</span>
                                    </Space>
                                }
                                name="description"
                            >
                                <Input.TextArea
                                    placeholder="Nhập mô tả thể loại (tùy chọn)"
                                    className="form-textarea"
                                    rows={3}
                                    maxLength={200}
                                    showCount
                                />
                            </Form.Item>
                        </Col>
                    </AntRow>
                    
                    <Divider style={{ margin: '16px 0' }} />
                    
                    <div className="modal-actions">
                        <Button
                            onClick={handleCancelEditCategory}
                            className="cancel-button"
                            icon={<CloseOutlined />}
                        >
                            Hủy
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="save-button"
                            icon={<EditOutlined />}
                            loading={isLoading}
                        >
                            Cập nhật
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};

export default CModalEditCategory;
